import { gql } from '@apollo/client';

export const GET_USER_BY_AUTH = gql`
  query userAccountByAuth {
    userByAuth {
      id
      firstName
      lastName
      middleName
      email
      bun
      isActive
      defaultProjectId
      lobEmployeeId
      toolRooms {
        id
        name
        description
        barCode
      }
      defaultProject {
        id
        name
        jobNumber
        subJobNumber
      }
      roles {
        id
        name
        description
      }
      employee {
        id
        imageUrl
        lobEmployeeId
        persona
      }
      permissionScopes {
        id
        permission {
          id
          name
          description
        }
        scope {
          id
          name
        }
      }
    }
  }
`;
export const UPDATE_USER_DEFAULT_PROJECT = gql`
  mutation updateUserDefaultProject($updateUserDefaultProjectInput: UpdateUserDefaultProjectInput!) {
    updateUserDefaultProject(updateUserDefaultProjectInput: $updateUserDefaultProjectInput) {
      userAccount {
        id
        defaultProjectId
        defaultProject {
          id
          name
          jobNumber
          subJobNumber
        }
      }
    }
  }
`;
